import React, { ReactElement } from 'react'

import Field from '../../../../../../../1stlog-ui/src/components/Field'
import ReadonlyInput from '../../../../../../../1stlog-ui/src/components/Input/ReadonlyInput'

export const Servicelevel = (): ReactElement => {
  return (
    <>
      <Field name="sla" label="Servicelevel">
        <ReadonlyInput bigger />
      </Field>
    </>
  )
}
